import React, {useState, useEffect, useRef, useLayoutEffect} from 'react';
import axios from 'axios';
import './ret.css';
import FormData from 'form-data';
import {he} from './store';
import dayjs from 'dayjs';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, Link} from 'react-router-dom';

const Indo=(choo)=>{
const solji = useRef(0);

useEffect(()=>{
   
    solji.current = choo;
},[choo]);
return solji.current;
};

const Mwonha =()=>{
    const [Files, setFiles] = useState({info : []});
    const [sna, setsna] = useState(0);
    const [insoo, setinsoo] = useState("");
    const [kakye, setkakye] = useState([]);
    const [peri, setperi] = useState(3);
    const [sigan, setsigan] = useState(0);
    const [kulli, setkulli] = useState(false);
    const [jiral, setjiral] = useState();
    const [screen, setscreen] = useState(false);
    const [ill, setill] = useState({a:"", b : []});
    const [pibot, setpibot] = useState(false);
    const [jolso, setjolso] = useState({a:"",b:"",c:1});
    const [pach, setpach]=useState({a:false,b:""});
    const vangu = useRef();
    const [sizip, setsizip] = useState(0);
    const fale = useSelector(state => state.mahena);
    const dispatch = useDispatch();
    const forads = useLocation();
    const jas =(e)=>{
      
        document.querySelector('.suent').classList.remove('suent');
        if(e.target.getAttribute('name') == "first"){
            document.getElementsByName('first')[0].classList.add('suent');
            document.title = "광고유형선택 - 돌파공모";
            setsna(0);
        }else if(e.target.getAttribute('name') == "second"){
            document.getElementsByName('second')[0].classList.add('suent');
            document.title = "기업전용첨삭 - 돌파공모";
            setsna(1);
        }else if(e.target.getAttribute('name') == "third"){
            document.getElementsByName('third')[0].classList.add('suent');
            document.title = "광고안내 - 돌파공모";
            setsna(2);
        };
    };

    useLayoutEffect(()=>{
        window.scrollTo(0,0);
    },[]);

    useEffect(()=>{},[sna]);
    useEffect(()=>{nasi();  document.title = "광고유형선택 - 돌파공모";},[]);
    const removes=(e)=>{
        e.preventDefault();
      
        const removeTargetId = e.target.dataset.index;
        const removeTarget = document.getElementById(removeTargetId);
    
        const files = document.getElementsByName('info')[0].files;
      
        
        const dataTranster = new DataTransfer();      
        Array.from(files).filter(file => file.lastModified != removeTargetId)
                        .forEach(file => {dataTranster.items.add(file);});
        document.getElementsByName('info')[0].files = dataTranster.files;
    
      
        setFiles({...Files, info : dataTranster.files});
        removeTarget.remove();
    };

    const kulja =(e)=>{
        setkulli(true);
        document.getElementById("zepu").classList.remove("happy");
        const kulla = document.querySelector('.kulji');
        const suua = document.querySelector('.suuu');
        const beea = document.querySelector('.beei');
        const inuu = document.querySelector('.innum');
        
        kulla.addEventListener('input', ()=>{
            suua.innerText = `${kulla.value.length}자 ` + bytehap(kulla) + `btye`;
            beea.innerText = `${(Math.floor(kulla.value.length / 1000)+1)*40000}원`;
            const pric = (Math.floor(kulla.value.length / 1000)+1)*40000;
            const kpric = Number(pric);
          
           // inuu.value = kpric.toLocaleString('ko-KR');
            inuu.value = kpric
        });
    };
    
    const pezi=(e)=>{
    setkulli(false);
    const kulla = document.querySelector('.kulji');
    const suua = document.querySelector('.suuu');
    const beea = document.querySelector('.beei');
    let prc;
    if(kulla.value.length == 0){
        prc = 0;
    }else{
        prc = (Math.floor(kulla.value.length / 1000)+1)*40000;
    };
    
    kulla.value = "";
    suua.innerText = "글자수";
    beea.innerText = "비용";
    const uipd = document.querySelector('.innum').value;
  
    setjiral(prc);
    };

    const bytehap=(e)=>{
        let byte = 0;
        for(let i = 0; i < e.value.length; i++){
            if (/[\sa-zA-Z0-9`~!@#$%^&*()_+-={}\[\];':",./<>?]/.test(e.value[i])) {
                byte++;
            }else{
                byte = byte+2;
            };
        };
        return byte;
    };

    const overgo =(e)=>{
        const kama = document.createElement('img');
        
        let sisi = e.pageX - e.offsetX;
        let zizi = e.pageY - e.offsetY;
       
        kama.src = e.target.src;
        kama.className = "marma";
        kama.style.left = sisi+"px";
        kama.style.top = zizi+"px";
        kama.onmouseout = outgo;
        e.target.parentNode.appendChild(kama);
    };

    const outgo =(e)=>{
        e.target.className = "marma bande";
        const mich = setTimeout(() => {
            e.target.remove();
            clearTimeout(mich);
        }, 600);
       // e.target.remove();
    };

    const checkfo =(e)=>{
            const sssing = e.target.id === "ssii" ? "pianm" : "bianm";
            const compa =  5*1024*1024;
          
            const prh = document.querySelector('#worksh');
            const files = Array.from(e.target.files);
            for(let f in files){
                if(files[f].size > compa){
                    e.target.value = "";
                    document.getElementById(sssing).textContent = "5MB 이하로 업로드해주세요";
                    return;
                }; 
            };
            files.forEach(file => {
                const parx = document.createElement('p');
                parx.id = file.lastModified;
                const button = document.createElement('button');
                button.onclick = removes;
                button.dataset.index = file.lastModified;
                button.innerText = "X";
                button.style.marginLeft = "5px";
                parx.innerText = file.name;
                parx.appendChild(button);
                let iama;
                const adm = ["image/jpeg", "image/png"];
                if(adm.includes(file.type)){
                  
                    iama = document.createElement('img');
                    iama.src = URL.createObjectURL(file);
                    iama.className = "wooja";
                    iama.onmouseover = overgo;
                    parx.appendChild(iama);
                };
                prh.appendChild(parx); 
            });
            if(Files.info.length > 0){
               
                const dataTranster = new DataTransfer();      
                Array.from([...Files.info, ...e.target.files]).forEach(file => {dataTranster.items.add(file);});
                document.getElementsByName('info')[0].files = dataTranster.files;
               
                setFiles({...Files, info : [...dataTranster.files]});
            }else{
            setFiles({...Files, info : [...e.target.files]});
            };
            };
           
    const kkk= async (e)=>{    
        e.preventDefault();
       
        const door = e.target.buta.value;
        const sssing = door === "sug1" ? "pianm" : "bianm";
        const tonight = dayjs().format('YYYY-MM-DD');
        const shot = new FormData();
        if(e.target.title.value.trim().length === 0){
            document.getElementById(door === "sug1" ? "sore" : "damn").classList.add('happy');
            return;
        };
        if(e.target.holder.value.trim().length === 0){
            document.getElementById(door === "sug1" ? "dewa" : "neva").classList.add('happy');
            return;
        };
        if(e.target.mails.value.trim().length === 0){
            document.getElementById(door === "sug1" ? "maku" : "namu").classList.add('happy');
            return;
        };
        shot.append('title', e.target.title.value);
        shot.append('holder',e.target.holder.value);
        let adup;
        if(door == 'sug1'){
            const firs = jolso?.a.slice(0, -1);
            const ends = jolso?.b;
            if(firs.trim().length === 0 || ends.trim().length === 0){
                return;
            };
            shot.append('perio', jolso?.c);
            shot.append('cost', (pach?.b * jolso?.c).toLocaleString('ko-KR') );
            shot.append('start', dayjs(firs).format('YYYY-MM-DD'));
            shot.append('end', dayjs(ends).format('YYYY-MM-DD'));
            shot.append('pick', pach?.a);
            adup = fale.post.map((a)=>{
                if(a.title == e.target.title.value){
                    // shot.append('posts', 
                    //     JSON.stringify({...a, ad : pach?.a, ads : moment(firs).format('YYYY-MM-DD'), ade : moment(ends).format('YYYY-MM-DD')}).slice(1,-1));
                   return {...a, ad : pach?.a, ads : dayjs(firs).format('YYYY-MM-DD'), ade : dayjs(ends).format('YYYY-MM-DD')};
                }else{
                    // shot.append('posts', JSON.stringify(a).slice(1,-1));
                    return a;
                };
            });
            shot.append('posts', JSON.stringify(adup));

        }else{
            if(e.target.cost.value.trim().length === 0){
                document.getElementById("zepu").classList.add("happy");
                return;
            };
            shot.append('perio', e.target.on7.value);
            shot.append('cost', e.target.cost.value);
            shot.append('pick', e.target.suntac.value);
        };

        // if(peri == 4  && door == 'sug1'){
        //     shot.append('perio', e.target.chooga.value);
        // }else{
        //     shot.append('perio', e.target.on7.value);
        // }
        shot.append('today', tonight);
        shot.append('type', door);
        // shot.append('cost', e.target.cost.value);
        // shot.append('pick', e.target.suntac.value);
        shot.append('mails', e.target.mails.value);
        shot.append('tels', e.target.tels.value);
        shot.append('story', e.target.story.value);
        if(Files.info.length > 0) {
            Files.info.map((kona,i)=>shot.append('info',kona));
        }else{
            shot.append('info', "");
        };
        const oiu = await axios.post(`/api/suggest/${door}`,shot, {headers: {"Content-Type" : "multipart/form-data"}})
        .then(eah=>{ setsna(4); setscreen(true); dispatch(he({...fale, post : adup})); }).catch(err=>{
            if(err.response?.data?.condition === "typenot"){
                alert("요청 분야를 확정해주세요");
            };
            if(err.response?.data?.condition === "nonetitle"){
                document.getElementById(door === "sug1" ? "sore" : "damn").classList.add('happy');
            };
            if(err.response?.data?.condition === "noneholder"){
                document.getElementById(door === "sug1" ? "dewa" : "neva").classList.add('happy');
            };
            if(err.response?.data?.condition === "nonemail"){
                document.getElementById(door === "sug1" ? "maku" : "namu").classList.add('happy');
            };
            if(err.response?.data?.condition === "nonecost"){
                document.getElementById("zepu").classList.add('happy');
            };
            if(err.response?.data?.success == "overfile"){
                document.getElementById(sssing).textContent = "5MB 이하로 업로드해주세요";
            };
            if(err.response?.data?.success == "overtotal"){
                document.getElementById(sssing).textContent = "업로드 파일은 최대 5개입니다";
            };
        });
    };

    const sootsu=(e)=>{
        const val=e.target.value.replace(/[^\d-]/g, '');
      
        setinsoo(val);
    };
  
    const sumva =(e)=>{
     
        if(["패키지1","패키지2","패키지3","패키지4","패키지5"].includes(e.target.value)){
           
            switch(e.target.value){
                case "패키지1" :
                    setkakye([10000, 20000, 30000, 40000, ""]);
                    break;
                case "패키지2" :
                    setkakye([20000, 30000, 40000, 50000, ""]);
                    break;  
                case "패키지3" :
                    setkakye([8000, 15000, 20000, 24000, ""]);
                    break;
                case "패키지4" :
                    setkakye([5000, 8000, 11000, 14000, ""]);
                    break;
                case "패키지5" :
                    setkakye([1000, 2000, 3000, 4000, ""]);
                    break;              
            }; 
        };
        if(["1주","2주","3주","1달","기타"].includes(e.target.value)){
            switch(e.target.value){
                case "1주" :
                    setperi(0);
                    break;
                case "2주" :
                    setperi(1);
                    break;    
                case "3주" :
                    setperi(2);
                    break;
                case "1달" :
                    setperi(3);
                    break;        
                case "기타" :
                    setperi(4);
                    break;    
            };
        };
    };

    const zumva=(e)=>{
        // if(["공모전","연구계획","프로젝트","사내활동","기타"].includes(e.target.value)){
        //     switch(e.target.value){
                
        //     };
        // };
        if(["24시간","48시간","72시간"].includes(e.target.value)){
            switch(e.target.value){
                case "24시간" :
                    setsigan(40000);
                    break;
                case "48시간" :
                    setsigan(20000);
                    break;    
                case "72시간" :
                    setsigan(0);
                    break;      
            };
        };
    };
    
    const nasi =()=>{
       // document.querySelector('.newca').classList.replace('newca','mnewco');
        const today = new Date();
        const mont = today.getMonth()+1;
        let arrayday = [today.getDate()];
        for(let i = 0; i <= 120; i++){
           arrayday.push(new Date(today.setDate(today.getDate() + 1)).getDate());
        };
        setill({a : mont, b : arrayday});
    };

    const lupin =(e)=>{
        const lumico = e.target.parentNode.previousElementSibling;
        lumico.classList.remove('happy');
    };

    const jiuki=(e)=>{
        setpibot(false);
        document.querySelector(".ibbu").remove();
        const yuyu = document.querySelectorAll(".mday1");
        yuyu.forEach((you)=>{
            you.classList.remove("nanan","balga","palga","macka");
        });
        //e.target.removeEventListener("click", jiuki);
        setjolso({a:"",b:"",c:1});
        setpach({a:false,b:""});
        document.querySelector(".ajiko")?.classList.remove("ajiko");
        document.querySelector(".aiai").classList.replace("aiai", "biran");
    
    };

    const selld=(e)=>{
        if(pach.a == false){
            document.querySelector(".pakis").classList.add("hugaz");
            document.querySelector(".mhino").classList.remove("nohi");
            return;
        };
        if(pibot == false){
        vangu.current = e.target.getAttribute("num");
        const dayto = new Date();
        const daytos = new Date(dayto.setDate(dayto.getDate() + parseInt(vangu.current)));
        const star1 = daytos.getFullYear()+"."+(daytos.getMonth() < 9 ? "0"+(daytos.getMonth()+1) : daytos.getMonth()+1)+"."
        +(daytos.getDate() < 10 ? "0"+daytos.getDate() : daytos.getDate());
        setjolso({...jolso, a:star1+"~"});
     
        if(e.target.className !== "mday1"){
            e.target.parentNode.classList.add("palga");
            for(let i = 0; i < vangu.current; i++){
                e.target.parentNode.parentNode.childNodes[i].classList.add("nanan");
            };
        }else{
        e.target.classList.add("palga");
        for(let i = 0; i < vangu.current; i++){
            e.target.parentNode.childNodes[i].classList.add("nanan");
        };
        }
        setpibot(true);
        document.querySelector(".biran").classList.replace("biran","aiai");
     
        }else{
            const prevna = vangu.current;
            vangu.current = e.target.getAttribute("num");
           
            const gapd = parseInt(vangu.current) - parseInt(prevna)+1;
            const dayto = new Date();
            const daytos = new Date(dayto.setDate(dayto.getDate() + parseInt(vangu.current)));
            const star2 = daytos.getFullYear()+"."+(daytos.getMonth() < 9 ? "0"+(daytos.getMonth()+1) : daytos.getMonth()+1)+"."
            +(daytos.getDate() < 10 ? "0"+daytos.getDate() : daytos.getDate());
            if(prevna !== vangu.current){
                document.querySelector(".palga").classList.add("macka");
            };
            const vapa = parseInt(vangu.current)+1;
            if(e.target.className == "mdaymon" || e.target.className == "slar"){
                e.target.parentNode.classList.replace("balga","palga");
                 const gae = e.target.parentNode.parentNode.childNodes;
                 for(let i = vapa; i < gae.length; i++){
                     e.target.parentNode.parentNode.childNodes[i].classList.add("nanan");
                 };
                 const remo = document.querySelectorAll(".balga");
                 remo.forEach((each)=>{
                     each.classList.add("macka");
                 });        
                     const poy = document.createElement("span");
                     poy.innerHTML = "X"
                     poy.className = "ibbu";
                     e.target.parentNode.appendChild(poy);
                     poy.addEventListener("click", jiuki);
                 setjolso({...jolso, b:star2,c:gapd});
                 setpibot(false);
            }else{
                e.target.classList.replace("balga","palga");
                // e.target.classList.add("palga");
                 // e.target.classList.add("macka");
                 // document.querySelector(".palga").classList.add("macka");
                 const gae = e.target.parentNode.childNodes;
                 for(let i = vapa; i < gae.length; i++){
                     e.target.parentNode.childNodes[i].classList.add("nanan");
                 };
                 const remo = document.querySelectorAll(".balga");
                 remo.forEach((each)=>{
                     each.classList.add("macka");
                 });
               //  const jyu = document.querySelectorAll(".palga");
                 
                     const poy = document.createElement("span");
                     poy.innerHTML = "X"
                     poy.className = "ibbu";
                     e.target.appendChild(poy);
                     poy.addEventListener("click", jiuki);
                 setjolso({...jolso, b:star2,c:gapd});
                 setpibot(false);
        }; 
    };
    };
    const noeffec =(e)=>{
        e.stopPropagation();
    };
    const sellov=(e)=>{
      
        if(pibot == true){
        const overa = e.target.getAttribute("num"); 
        const remo = parseInt(vangu.current)+1;
    
        if(e.target.className == "mdaymon" || e.target.className == "slar"){
            for(let i=remo; i<=overa; i++){
                e.target.parentNode.parentNode.childNodes[i].classList.add("balga");
            };
        }else{
            for(let i=remo; i<=overa; i++){
                e.target.parentNode.childNodes[i].classList.add("balga");
            };
        };
        };
    };

    const sellut=(e)=>{
        if(pibot == true){
            const remo = document.querySelectorAll(".balga");
            remo.forEach((each)=>{
                each.classList.remove("balga");
            });
         
        };
    };

    const collar=(e)=>{
        document.querySelector(".ajiko")?.classList.remove("ajiko");
        document.querySelector(".pakis").classList.remove("hugaz");
        document.querySelector(".mhino").classList.add("nohi");
        if(pach.a == e.target.getAttribute("pack")){
        setpach({a: false ,b:""});
     
      //  e.target.parentNode.classList.remove("ajiko");
        }else{
        switch(e.target.getAttribute("pack")){
            case "a" :
                setpach({a: "패키지A", b: 110000});
                break;
            case "b" :
                setpach({a: "패키지B", b: 90000});
                break;    
            case "c" :
                setpach({a: "패키지C", b: 70000});
                break;
            case "d" :
                setpach({a: "돌파메인", b: 80000});
                break;        
            case "e" :
                setpach({a: "돌파추천", b: 60000});
                break;  
            case "f" :
                setpach({a: "돌파스페셜", b: 40000});
                break;
            case "g" :
                setpach({a: "돌파주목", b: 30000});
                break;
            case "h" :
                setpach({a: "이벤트배너", b: 30000});
                break;    
            case "i" :
                setpach({a: "리스트탑", b: 25000});
                break;    
        };
        e.target.parentNode.classList.add("ajiko")
      
        };
    };
    const exap=(e)=>{
     
        const hwamen = document.querySelector(".omoi");
        hwamen.style.display= "block";
        const ingirl = document.querySelector(".mamai");
        ingirl.style.display= "block";
    };

    const saraji =(e)=>{
        e.stopPropagation();
        document.querySelector(".omoi").style.display = "none";
        document.querySelector(".mamai").style.display = "none";
    };
    const saraje=(e)=>{
        e.stopPropagation();
        document.querySelector(".omoi").style.display = "none";
        document.querySelector(".mamai").style.display = "none";
    };
    let sooha = 0;

    const voki=(e)=>{
        if(e.target.getAttribute("name") == "pici"){
            document.querySelectorAll(".mbanas")[1].classList.add("maga");
            document.querySelectorAll(".mbanas")[0].classList.remove("maga");
        }else{
            document.querySelectorAll(".mbanas")[0].classList.add("maga");
            document.querySelectorAll(".mbanas")[1].classList.remove("maga");
        };
    };

    return(
    <>
    {sna == 4 && <div className='pyoji'>
        <p>안내드리겠습니다!</p>
        <Link to="/" style={{textDecoration:"none"}}>메인페이지</Link>
        </div>}
    {sna == 4 ? "" :     
    <div className='mkeye'>
     <span onClick={jas} name="first" className='mkeyf suent'>광고유형선택</span>
     <span onClick={jas} name="second" className='mkeyf'>기업전용첨삭</span>
     <span onClick={jas} name="third" className='mkeyf'>광고안내</span>
    </div>}

    {/* {screen == true && <div className='pyoji'><p>안내드리겠습니다!</p></div>}
    <div className='mkeye'>
     <span onClick={jas} name="first" className='mkeyf suent'>광고유형선택</span>
     <span onClick={jas} name="second" className='mkeyf'>기업전용첨삭</span>
     <span onClick={jas} name="third" className='mkeyf'>광고안내</span>
    </div> */}

    {sna == 0 &&  <form onSubmit={kkk}>
    <div className='mnewco'>
      <div className='pakis' style={{width:"98%", height:"98px", border:"1px solid #009935"}}>
        <div className='mhino nohi'><p className='hina'><span>패키지를 선택하세요</span></p></div>
        <div className='nooks'>
            <p onClick={collar} pack="a" className='packp1'>패키지A</p>
            {/* <p onClick={exap} className='packp2'>보기</p> */}
        </div>
        <div className='nooks'>
            <p onClick={collar} pack="b" className='packp1'>패키지B</p>
            {/* <p onClick={exap} className='packp2'>보기</p> */}
        </div>
        <div className='nooks'>
            <p onClick={collar} pack="c" className='packp1'>패키지C</p>
            {/* <p onClick={exap} className='packp2'>보기</p> */}
        </div>
        <div className='nooks'>
            <p onClick={collar} pack="d" className='packp1'>돌파메인</p>
            {/* <p onClick={exap} className='packp2'>보기</p> */}
        </div>
        <div className='nooks'>
            <p onClick={collar} pack="e" className='packp1'>돌파추천</p>
            {/* <p onClick={exap} className='packp2'>보기</p> */}
        </div>
        <div className='nooks'>
            <p onClick={collar} pack="f" className='packp1'>돌파스페셜</p>
            {/* <p onClick={exap} className='packp2'>보기</p> */}
        </div>
        <div className='nooks'>
            <p onClick={collar} pack="g" className='packp1'>돌파주목</p>
            {/* <p onClick={exap} className='packp2'>보기</p> */}
        </div>
        <div className='nooks'>
            <p onClick={collar} pack="h" className='packp1'>이벤트배너</p>
            {/* <p onClick={exap} className='packp2'>보기</p> */}
        </div>
        <div className='nooks'>
            <p onClick={collar} pack="i" className='packp1'>리스트탑</p>
            {/* <p onClick={exap} className='packp2'>보기</p> */}
        </div>
      </div>
      <div className='miljong'>
        <div className='mmonth1'><span className='mmonth2'>{ill?.a}{' '}월</span></div>
        <div className='mweek1'>{ill.b.length>0 && ill.b.map((day,i)=>{
                if(day == 1){
                    if(i == 0){
                    return (<span className='mday1' onClick={selld} num={i} onMouseOver={sellov} onMouseOut={sellut}>
                        <span className='mdaymon'  num={i}>{ill?.a+sooha}</span><span className='slar'  num={i}>/</span>{day}</span>)    
                    }else{
                        sooha++;
                        if(ill?.a+sooha > 12){
                            return (<span className='mday1' onClick={selld} num={i} onMouseOver={sellov} onMouseOut={sellut}>
                                <span className='mdaymon'  num={i}>{ill?.a+sooha-12}</span><span className='slar'  num={i}>/</span>{day}</span>)
                        }else{
                            return (<span className='mday1' onClick={selld} num={i} onMouseOver={sellov} onMouseOut={sellut}>
                                <span className='mdaymon'  num={i}>{ill?.a+sooha}</span><span className='slar'  num={i}>/</span>{day}</span>)        
                        }
                    }
                }else{return (
                <span className='mday1' onClick={selld} num={i} onMouseOver={sellov} onMouseOut={sellut}>{day}</span>
                )}})
        }</div>
      </div>
      <div className='mbiyo'>
        <div className='biran'>
        <p><span>상품</span><span className='twent2'>{pach?.a}</span> <span>({jolso?.c}일)</span></p>
        <p><span>기간</span><span className='twent2'>{jolso?.a}{jolso?.b}</span></p>
        <p><span>금액</span><span className='twent2'>{(pach?.b * jolso?.c).toLocaleString('ko-KR')}원</span></p>
        </div>
      </div>
      <div className='omoi' onClick={saraji}>
     
      </div>
      <div className='mamai'>
            <div className='pashe'><span onClick={saraje}>X</span></div>
            <div>
                <div style={{paddingTop:"15px"}}><span>package title</span></div>
                <div className='cheo'>
                    <p>most preferred package</p>
                    <p>overwelmed choice for event</p>
                </div>
            </div>
            <div className='namoi'>
                <div className='ibaek'>
                    <div><p>선택하기 좋은 조건</p></div>
                    <div><p>10구좌 </p></div>
                </div>
                <div className='sambaek'>
                    <img src='' alt='manmun'/>
                </div>
            </div>
            <div className='majiro'>
                <a href='' target='_blank'> 
                <div className='majiro-a'>
                    <div className='sambaek'><span>광고를 더 알아볼까요?</span></div>
                    <div className='ibaek'><img src='' alt='goto ad'/></div>
                </div>
                </a>
            </div>
        </div>
    </div>
     <table className='mkimid'>
        <tbody>
            {/* <tr>
                <th>광고상품</th><td className='mmyung'><div>
                    <select onChange={sumva} name='suntac'>
                        <option value="선택">선택</option>
                        <option value="패키지1">패키지1</option>
                        <option value="패키지2">패키지2</option>
                        <option value="패키지3">패키지3</option>
                        <option value="패키지4">패키지4</option>
                        <option value="패키지5">패키지5</option>
                    </select></div></td>
            </tr> */}
            {/* <tr>
                <th>게재기간</th>
                <td className='ahall'>
                    <div><input type='radio' name='on7' id='ah1' value="1주" onChange={sumva} checked={peri == 0}/><label for='ah1'>1주</label></div>
                    <div><input type='radio' name='on7' id='ah2' value="2주" onChange={sumva} checked={peri == 1}/><label for='ah2'>2주</label></div>
                    <div><input type='radio' name='on7' id='ah3' value="3주" onChange={sumva} checked={peri == 2}/><label for='ah3'>3주</label></div>
                    <div><input type='radio' name='on7' id='ah4' value="1달" onChange={sumva} checked={peri == 3}/><label for='ah4'>1달</label></div>
                    <div><input type='radio' name='on7' id='ah5' value="기타" onChange={sumva} checked={peri == 4}/><label for='ah5'>기타</label>
                    {peri == 4 && <input type='text' placeholder='기간' className='sides' name='chooga'/>}</div>
                </td>
            </tr> */}
            <tr>
                <th>첨부파일</th>
                <td><div className='honja' style={{fontSize:"15px"}}>파일선택<input type='file' className='filenm' onChange={checkfo} name='info' title='파일' id='ssii' multiple/></div>
                    <div id="worksh" className='hannjo'><span id="pianm" className='sayona'></span></div>
                </td>
            </tr>
            {/* <tr><th>비용</th><td className='msuty'><input type='text' name='cost' value={kakye?.length > 0 ? kakye[peri].toLocaleString('ko-KR') : ""} readOnly/><label>만원 (부가세 미포함)</label></td></tr> */}
            <tr><th id ="sore">공모명</th><td className='mmyung'><input type='text' name='title' value={forads.state?.posta && forads.state.posta.title } onFocus={lupin}/></td></tr>
            <tr><th id="dewa">담당자</th><td className='mmyung'><input type='text' name='holder' value={forads.state?.sinsa && forads.state.sinsa.name } onFocus={lupin}/></td></tr>
            {/* <tr><th>연락처</th><td className='mmyung'><input type='text' value={insoo} onChange={sootsu} name='tels'/></td></tr> */}
            <tr><th>연락처</th><td className='mmyung'><input type='text' value={forads.state?.sinsa && forads.state.sinsa.tels} onChange={sootsu} name='tels'/></td></tr>
            <tr><th id="maku">이메일</th><td className='mmyung'><input type='email' name='mails' value={forads.state?.sinsa && forads.state.sinsa.mail} onFocus={lupin}/></td></tr>
            <tr><th>추가 사항</th><td className='mmyung'><textarea className='marey' name='story'/></td></tr>
        </tbody>
     </table>   
     <button onSubmit={kkk} value='sug1' name='buta' className='mnyung'>제출</button>
    </form>} 

      {sna == 1 && <form onSubmit={kkk}>
     <table className='mkimid'>
        <tbody>
            <tr>
                <th>첨삭대상</th>
                <td className='mmyung'>
                    <div style={{height:"40px"}}>
                    <select style={{width:"200px", height:"40px"}} onChange={zumva} name='suntac'>
                        <option value="선택">선택</option>
                        <option value="공모전">공모전 안내문</option>
                        <option value="연구계획">연구계획서</option>
                        <option value="프로젝트">프로젝트 기획 및 평가서</option>
                        <option value="사내활동">사내 활동(인사고과반영)</option>
                        <option value="기타">기타</option>
                    </select>
                </div></td>
            </tr>
            <tr>
                <th>완료기간</th>
                <td className='ahall'>
                    <div className='fonwd'><input type='radio' name='on7' id='ah1' value="24시간" onChange={zumva} checked={sigan == 40000}/><label for='ah1' className='fon14'>24시간</label></div>
                    <div className='fonwd'><input type='radio' name='on7' id='ah2' value="48시간" onChange={zumva} checked={sigan == 20000}/><label for='ah2' className='fon14'>48시간</label></div>
                    <div className='fonwd'><input type='radio' name='on7' id='ah3' value="72시간" onChange={zumva} checked={sigan == 0}/><label for='ah3' className='fon14'>72시간</label></div>
                </td>
            </tr>
            <tr>
                <th>첨부파일</th>
                <td><div className='honja' style={{fontSize:"14px"}}>파일선택<input type='file' className='filenm' onChange={checkfo} name='info' title='파일' id='nnii' multiple/></div>
                    <div id="worksh" className='hannjo'><span id="bianm" className='sayona'></span></div>
                </td>
            </tr>
            <tr><th id="zepu">비용</th>
            <td className='msuty'><input type='text' className='innum' name='cost' value={jiral > 0 ? (parseInt(jiral)+parseInt(sigan)).toLocaleString('ko-KR') : ""} readOnly/><label className='sekifon'>원 (부가세 미포함)</label>
            <span onClick={kulja} className='sekim'>글자수세기</span></td></tr>
            <tr><th id="damn">의뢰명</th><td className='mmyung'><input type='text' name='title' onFocus={lupin}/></td></tr> 
            <tr><th id="neva">의뢰자</th><td className='mmyung'><input type='text' name='holder' onFocus={lupin}/></td></tr>
            <tr><th>연락처</th><td className='mmyung'><input type='text' value={insoo} onChange={sootsu} name='tels'/></td></tr>
            <tr><th id="namu">이메일</th><td className='mmyung'><input type='email' name='mails' onFocus={lupin}/></td></tr>
            <tr><th>추가사항</th><td className='mmyung'><textarea className='marey' name='story'/></td></tr> 
            <div className={kulli ? 'mmapo' : 'manon'} onClick={pezi}>
                <div className='mmaho' onClick={e=>e.stopPropagation()}>
                <p className='pee2' onClick={pezi}>X</p>
                <textarea className='kulji' style={{height:"260px"}}></textarea>
                <span className='suuu'>글자수</span>
                <span className='beei'>비용</span>
                <p className='pee' onClick={pezi}>확인</p>
                </div>
            </div>
        </tbody>
     </table>   
     <button onSubmit={kkk} value='sug2' name='buta' className='mnyung'>제출</button>
    </form>}

    {sna == 2 &&

<div>
    <div style={{marginBottom:"50px"}}>
    <span onClick={voki} name="pici" className='piroya' style={{marginRight:"10px"}}>PC</span>
    <span onClick={voki} name="mobip" className='piroya' style={{marginLeft:"10px"}}>Mobile</span>
</div>
<div className='mbanas maga'>
    <div className='mbanas1'>
        <img src={`${process.env.PUBLIC_URL}/pc-ad1.png`} />
    </div>
    <div className='mbanas2'>
        <div className='mbanas4' style={{marginTop:"0"}}><p className='banaf'>돌파메인</p><p><span>PC & MOBILE</span><span className='eights'>일 8만원</span></p></div>    
        <div className='mbanas4'><p className='banaf'>돌파추천</p><p><span>PC & MOBILE</span><span className='eights'>일 6만원</span></p></div>
        <div className='mbanas4'><p className='banaf'>돌파스페셜</p><p><span>PC & MOBILE</span><span className='eights'>일 4만원</span></p></div>
        <div className='mbanas4'><p className='banaf'>돌파주목</p><p><span>PC & MOBILE</span><span className='eights'>일 3만원</span></p></div>
        <div className='mbanas4'><p className='banaf'>이벤트배너</p><p><span>PC & MOBILE</span><span className='eights'>일 3만원</span></p></div>
        <div className='mbanas4'><p className='banaf'>리스트탑</p><p><span>PC & MOBILE</span><span className='eights'>일 2.5만원</span></p></div>
        <div className='mbanas4 he70'><p>패키지A</p><p><span>PC & MOBILE</span><span className='eights'>일 11만원</span></p>
        <p className='fon10'>돌파메인, 돌파추천, 리스트탑</p></div>
        <div className='mbanas4 he70'><p>패키지B</p><p><span>PC & MOBILE</span><span className='eights'>일 9만원</span></p>
        <p className='fon10'>돌파메인, 돌파스페셜, 리스트탑</p></div>
        <div className='mbanas4 he70'><p>패키지C</p><p><span>PC & MOBILE</span><span className='eights'>일 7만원</span></p>
        <p className='fon10'>돌파추천, 돌파주목, 리스트탑</p></div>
    </div>
</div>
<div className='mbanas'>
    <div className='mbanas1'>
        <img src={`${process.env.PUBLIC_URL}/mob-ad1.png`} />
    </div>
    <div className='mbanas2'>
        <div className='mbanas4' style={{marginTop:"0"}}><p className='banaf'>돌파메인</p><p><span>PC & MOBILE</span><span className='eights'>일 8만원</span></p></div>    
        <div className='mbanas4'><p className='banaf'>돌파추천</p><p><span>PC & MOBILE</span><span className='eights'>일 6만원</span></p></div>
        <div className='mbanas4'><p className='banaf'>돌파스페셜</p><p><span>PC & MOBILE</span><span className='eights'>일 4만원</span></p></div>
        <div className='mbanas4'><p className='banaf'>돌파주목</p><p><span>PC & MOBILE</span><span className='eights'>일 3만원</span></p></div>
        <div className='mbanas4'><p className='banaf'>이벤트배너</p><p><span>PC & MOBILE</span><span className='eights'>일 3만원</span></p></div>
        <div className='mbanas4'><p className='banaf'>리스트탑</p><p><span>PC & MOBILE</span><span className='eights'>일 2.5만원</span></p></div>
        <div className='mbanas4 he70'><p>패키지A</p><p><span>PC & MOBILE</span><span className='eights'>일 11만원</span></p>
        <p className='fon10'>돌파메인, 돌파추천, 리스트탑</p></div>
        <div className='mbanas4 he70'><p>패키지B</p><p><span>PC & MOBILE</span><span className='eights'>일 9만원</span></p>
        <p className='fon10'>돌파메인, 돌파스페셜, 리스트탑</p></div>
        <div className='mbanas4 he70'><p>패키지C</p><p><span>PC & MOBILE</span><span className='eights'>일 7만원</span></p>
        <p className='fon10'>돌파추천, 돌파주목, 리스트탑</p></div>
    </div>
</div>

<div className='banas3'>
    <p></p>
</div>
    
    </div>}
    </>
    );
};

export default Mwonha;